import axios from 'axios';

class Model {

  constructor(store) {
    this._data = [];
    this.store = store;
    this.modelName;
    this.axios = axios.create({
      baseURL: process.env.API_URL
    });
  }

  label() {
    return this.modelName || 'some_model';
  }

  get list() {
    let data;

    if (this.store) {
      data = this.store.state.models[this.label()];
    } else {
      data = this._data;
    }

    if (!Array.isArray(data)) {
      return [data];
    } else {
      return data;
    }
  }

  get data() {
    let data;

    if (this.store) {
      data = this.store.state.models[this.label()];
    } else {
      data = this._data;
    }

    if (Array.isArray(data)) {
      return data[0];
    } else {
      return data;
    }
  }

  set data(data) {
    this.updateData(data);
  }

  updateData(data, mustDelete = false) {
    if (Array.isArray(data) || data === null) {
      this._data = data;
    } else if (data.hasOwnProperty('_id')) {
      let index = -1;
      this._data.forEach((item, i) => {
        if (item && item._id === data._id) {
          index = i;
          if (!mustDelete) {
            Object.assign(item, data);
          }
        }
      });
      if (index === -1) {
        this._data.push(data);
      } else if (mustDelete) {
        this._data.splice(index, 1);
      }
    } else if (data) {
      console.warn('Setting non Array data without _id property. It can causes undesired behaviours.');
      this._data = data;
    }

    if (this.store) {
      this.store.commit('SET_MODEL_DATA', { model: this.label(), data: this._data });
    }
  }

  index(params = {}) {
    const query = this.objectToQuery(params);

    return new Promise((resolve, reject) => {
      this.axios.get(`/${this.modelName}?${query}`).then(({ data }) => {
        this.data = data;
        resolve(data);
      }).catch((error) => {
        reject(error);
      });
    })
  }

  show(id) {
    return new Promise((resolve, reject) => {
      let path = encodeURI(`/${this.modelName}/${id}`);
      this.axios.get(path).then(({ data }) => {
        this.data = data;
        resolve(data);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  objectToQuery(obj) {
    return Object.keys(obj).map((key) => {
      let val =  obj[key];
      val = typeof(val) == 'object' ? JSON.stringify(val) : val;
      val = typeof(val) == 'undefined' ? '' : val;
      return `${key}=${encodeURIComponent(val)}`;
    }).join('&');
  }

}

export default Model;
